import { render, staticRenderFns } from "./WholesaleBillProduct.vue?vue&type=template&id=d6337fec"
import script from "./WholesaleBillProduct.vue?vue&type=script&lang=js"
export * from "./WholesaleBillProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports